<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <core-card [actions]="[]">
            <div class="card-title w-100">
                <div [ngClass.xl]="'float-left'" [ngClass.md]="'float-left'" [ngClass.sm]="'mb-075'">
                    <label class="d-flex align-items-center">
                        <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control"
                               [(ngModel)]="searchKeyword"/>
                    </label>
                </div>
                <div class="float-right">
                    <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.md]="'d-inline-block mr-2'" [ngClass.sm]="'d-none'">
                        <label class="d-flex align-items-center">{{"SHOW" | translate}}
                            <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </label>
                    </div>
                    <a class="btn btn-outline-primary text-primary" (click)="modalOpen(addFigure, null)"
                       *ngIf="_authenticationService.hasCapability('create_user_figure')">{{'ADD' | translate}}</a>
                </div>
                <div class="clearboth"></div>
            </div>

            <!--desktop-->
            <div class="card-body px-0 pb-0" *ngIf="_utilService.isDesktop">
                <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [rows]="figuresList()" [headerHeight]="config.headerHeight"
                               [scrollbarH]="config.scrollbarH" [rowHeight]="config.rowHeight" [limit]="tableLimit"
                               [footerHeight]="config.footerHeight" [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}">
                    <ngx-datatable-column *ngFor="let col of config.columns" [name]="col.text" [prop]="col.value"
                                          [sortable]="col.sortable || false">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <span>{{ row[col.value] }}</span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="{{'ACTIONS' | translate}}" [sortable]="false">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div>
                                <button (click)="modalOpen(editFigure, row)" class="bg-transparent border-0 text-secondary pr-1"
                                        *ngIf="_authenticationService.hasCapability('edit_user_figure')">
                                    <i [data-feather]="'edit-2'" size="19"></i>
                                </button>
                                <button (click)="deleteFigure(row)" class="bg-transparent border-0 text-danger remove-item"
                                        *ngIf="_authenticationService.hasCapability('delete_user_figure')">
                                    <i [data-feather]="'trash-2'" size="19"></i>
                                </button>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>

            <!--mobile - tablet-->
            <div class="card-body px-0 pb-0" *ngIf="_utilService.isMobile || _utilService.isTablet">
                <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [rows]="figuresList()" [headerHeight]="config.headerHeight"
                               [scrollbarH]="config.scrollbarH" [rowHeight]="config.rowHeight" [limit]="tableLimit"
                               [footerHeight]="config.footerHeight" [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}">
                    <ngx-datatable-column *ngFor="let col of config.columns" [name]="col.text" [prop]="col.value" [width]="col.width || null"
                                          [sortable]="col.sortable || false">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div class="row list-item-mobile">
                                <div class="col-12" [ngClass.md]="'pl-0'">
                                    <span>{{ row[col.value] }}</span>
                                </div>
                                <div class="col-12 mt-075 text-right" [ngClass.md]="'pr-2'">
                                    <button (click)="modalOpen(editFigure, row)" class="bg-transparent border-0 text-secondary pr-1"
                                            *ngIf="_authenticationService.hasCapability('edit_user_figure')">
                                        <i [data-feather]="'edit-2'" size="19"></i>
                                    </button>
                                    <button (click)="deleteFigure(row)" class="bg-transparent border-0 text-danger remove-item"
                                            *ngIf="_authenticationService.hasCapability('delete_user_figure')">
                                        <i [data-feather]="'trash-2'" size="19"></i>
                                    </button>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>
        </core-card>
    </div>
</div>

<!-- Modal ADD -->
<ng-template #addFigure let-modal>
    <div class="modal-header">
        <div></div>
        <button type="button" class="close" (click)="modal.close()"
                aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0">
        <h3>{{"INSERT.INSERT_FIGURE" | translate}}</h3>
        <label [for]="'new_figure'">{{"PROFESSIONAL_FIGURE" | translate}}<sup class="text-danger">*</sup></label>
        <input name="new_figure" [(ngModel)]="new_figure" type="text" [id]="new_figure" class="form-control"/>
        <div class="font-error"
             *ngIf="showModalError && (!new_figure || new_figure.length < 1)">{{ 'ERRORS.FIELD_FIGURE_PROFESSIONAL' | translate }}</div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
        <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
            {{"CANCEL" | translate}}
        </button>
        <button (click)="addNewFigure()" type="submit" class="btn btn-primary w-150" rippleEffect>
            {{"SEND" | translate}}
        </button>
    </div>
</ng-template>
<!-- / Modal ADD -->

<!-- Modal EDIT -->
<ng-template #editFigure let-modal>
    <div class="modal-header">
        <div></div>
        <button type="button" class="close" (click)="modal.close()"
                aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0">
        <h3>{{"INSERT.EDIT_FIGURE" | translate}}</h3>
        <label [for]="'currentFigure.name'">{{"PROFESSIONAL_FIGURE" | translate}}<sup class="text-danger">*</sup></label>
        <input name="currentFigureName" [(ngModel)]="currentFigure.name" type="text" [id]="currentFigure.name" class="form-control"/>
        <div class="font-error"
             *ngIf="showModalError && (!currentFigure.name || currentFigure.name.length < 1)">{{ 'ERRORS.FIELD_FIGURE_PROFESSIONAL' | translate }}</div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
        <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
            {{"CANCEL" | translate}}
        </button>
        <button (click)="editCurrentFigure()" type="submit" class="btn btn-primary w-150" rippleEffect>
            {{"EDIT" | translate}}
        </button>
    </div>
</ng-template>
<!-- / Modal EDIT -->
